/**
 * AgentConversationListGroup
 *
 * Time-based grouping container for conversations
 * (Today, Yesterday, Last Week, Last Month, Older)
 */

import React from 'react';

const AgentConversationListGroup = ({ label, count, children }) => {
  return (
    <div className="agent-conversation-list-group">
      <div className="agent-conversation-list-group-header">
        <h2 className="agent-conversation-list-group-label">{label}</h2>
        {count !== undefined && (
          <span className="agent-conversation-list-group-count">({count})</span>
        )}
      </div>
      <div className="agent-conversation-list-group-items">
        {children}
      </div>
    </div>
  );
};

export default AgentConversationListGroup;
